var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultants(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.63 20.77a6 6 0 1 0-7.26 0A9 9 0 0 0 2 29a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1 9 9 0 0 0-5.37-8.23zM7 16a4 4 0 1 1 4 4 4 4 0 0 1-4-4zM4.07 28a7 7 0 0 1 13.86 0z",
    fill: "#112d55",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2196f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 14a1 1 0 0 1-.47-.12A1 1 0 0 1 17 13V5a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-5.7l-2.75 1.83A1 1 0 0 1 18 14zm2-10a1 1 0 0 0-1 1v6.13l1.45-1A1 1 0 0 1 21 10h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z",
    fill: "#0e9941",
    opacity: 1,
    "data-original": "#2196f3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 8h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z",
    fill: "#0e9941",
    opacity: 1,
    "data-original": "#2196f3",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultants);
export default __webpack_public_path__ + "static/media/consultants.dbdce33e7f33b5616135803353d261e3.svg";
export { ForwardRef as ReactComponent };